import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Loader2, LogIn } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../hooks/use-toast";

const AdminLogin = () => {
  const { login, isAuthenticated, loading } = useAuth();
  const [password, setPassword] = useState("");
  const { toast } = useToast();
  const navigate = useNavigate();

  if (isAuthenticated) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) {
      toast({ title: "Password required", variant: "destructive" });
      return;
    }
    const res = await login(password);
    if (res.success) {
      toast({ title: "Welcome back, Kyle!", description: "Logged in successfully." });
      navigate("/admin", { replace: true });
    } else {
      toast({ title: "Login failed", description: res.error, variant: "destructive" });
    }
  };

  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center px-6">
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage:
          "radial-gradient(circle at 20% 30%, #F5B12D 1px, transparent 1px), radial-gradient(circle at 70% 70%, #F5B12D 1px, transparent 1px)",
        backgroundSize: "40px 40px",
      }} />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets-gfyr7b9c.emergentagent.net/job_design-build-live-1/artifacts/pt3xqgqe_file_000000007bb48210bf689d869ac39baf_GEoBTL.png"
            alt="KJ Ground Force"
            className="h-24 w-auto object-contain mx-auto mb-6 drop-shadow-2xl"
          />
          <h1 className="font-display text-3xl text-white tracking-wide">
            ADMIN PORTAL
          </h1>
          <p className="text-gray-400 text-sm mt-2">Quote management dashboard</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-brand-dark-2 border border-white/10 rounded-lg p-8 shadow-2xl"
        >
          <div className="mb-6">
            <label className="text-xs font-bold text-brand-yellow tracking-wider mb-2 block">
              ADMIN PASSWORD
            </label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                autoFocus
                className="bg-brand-dark border-white/10 text-white h-12 pl-10 focus:border-brand-yellow"
              />
            </div>
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-brand-yellow hover:bg-brand-yellow-dark text-brand-dark font-bold tracking-wider text-sm h-12 rounded-md"
          >
            {loading ? (
              <>
                <Loader2 size={16} className="mr-2 animate-spin" />
                LOGGING IN...
              </>
            ) : (
              <>
                <LogIn size={16} className="mr-2" />
                LOG IN
              </>
            )}
          </Button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-gray-500 hover:text-brand-yellow text-xs tracking-wider transition-colors">
            ← BACK TO WEBSITE
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
